
export const SERVICE_URL = {
  LOGIN: `/login/`,
  GET_WORKSPASEPRODUCT: `/get-workspace-voice-flow`,
  GET_LIVEPRODUCT: `/get-voice-flow`,
  DELETE_PRODUCT: `/delete-workspace-json`,
  GET_CLIENTLIST: `/get-client-info/`,
  GET_VOICEARTIST: `/get_voiceartist/`,
  GET_COMMONRESPONSE: `/get_commonresponses/`,
  GET_RETURNALL: `/return-all/`,
  GET_DISPOSITION: `/get-disposition/`,
  INSERT_FILE:`/fileUpload/`,

  INSERTWORKSPACEFLOW: `/voicebot-workspace-jsonflow/`,
  UPDATEWORKSPACEFLOW: `/update-workspace-json`,
  UPDATELIVEJSON:`/update-json`,
  PUBLISHFLOW: `/voicebot-jsonflow/`,
  UPDATE_BASICUI: `/update-json`,
  PREVIEWCALL:`/call-initiation/`
};
